import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { API_URL } from "../config";

function Login({ onLoginSuccess }) {
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    setError("");
    setCargando(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "No se pudo iniciar sesión.");
        setCargando(false);
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("usuario", JSON.stringify(data.usuario));
      onLoginSuccess(data.usuario);
    } catch (err) {
      setError("Error de conexión con el servidor. Intenta de nuevo.");
      setCargando(false);
    }
  };

  return (
    <div style={styles.page}>
      <div className="login-tarjeta" style={styles.card}>
        <div style={styles.panelMarca}>
          <div style={styles.icono}>🛒</div>
          <h1 style={styles.titulo}>Gestión de Compras</h1>
          <p style={styles.subtitulo}>Colegio Alemán — Deutsche Schule Managua</p>
          <ul style={styles.lista}>
            <li>Solicitudes y cotizaciones</li>
            <li>Aprobaciones y pagos</li>
            <li>Actas y activos fijos</li>
          </ul>
        </div>

        <div style={styles.panelAcceso}>
          <h2 className="sin-subrayado" style={styles.bienvenida}>Inicia sesión</h2>
          <p style={styles.indicacion}>Entra con tu cuenta del colegio.</p>
          <div style={styles.botonWrap}>
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={() => setError("No se pudo iniciar sesión con Google.")}
              hosted_domain="dsm.edu.ni"
              text="signin_with"
              locale="es"
            />
          </div>

          {cargando && <p style={styles.info}>Verificando...</p>}
          {error && <p style={styles.error}>{error}</p>}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // Rayos diagonales sutiles (al estilo del fondo de bloqueo de Ubuntu),
    // pero en el azul institucional — un conic-gradient repetido genera las
    // líneas irradiando desde una esquina, y el radial-gradient encima las
    // va apagando hacia el resto de la pantalla para que no se vea recargado.
    background:
      "radial-gradient(140% 140% at 0% 100%, rgba(11,60,96,0) 0%, rgba(11,60,96,0.6) 45%, var(--tema-titulo, #0b3c60) 72%), " +
      "repeating-conic-gradient(from 210deg at -10% 115%, rgba(255,255,255,0.26) 0deg 1.2deg, transparent 1.2deg 6deg, rgba(254,201,0,0.38) 6deg 7.2deg, transparent 7.2deg 12deg), " +
      "var(--tema-titulo, #0b3c60)",
    padding: "1rem",
  },
  card: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    background: "#ffffff",
    borderRadius: 18,
    overflow: "hidden",
    maxWidth: 760,
    width: "100%",
    boxShadow: "0 16px 40px rgba(0,0,0,0.3)",
  },
  panelMarca: {
    padding: "2.5rem 2.2rem",
    color: "#ffffff",
    background: "var(--tema-titulo, #0b3c60)",
    borderRight: "4px solid var(--tema-acento, #fec900)",
  },
  icono: {
    width: 52,
    height: 52,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.7rem",
    borderRadius: 14,
    background: "var(--tema-acento, #fec900)",
    marginBottom: "1.1rem",
  },
  titulo: {
    fontSize: "1.6rem",
    lineHeight: 1.2,
    margin: "0 0 0.4rem",
  },
  subtitulo: {
    fontSize: "0.88rem",
    color: "#c7d0e0",
    margin: "0 0 1.4rem",
  },
  lista: {
    margin: 0,
    paddingLeft: "1.1rem",
    fontSize: "0.86rem",
    lineHeight: 1.8,
    color: "#e6ebf5",
  },
  panelAcceso: {
    padding: "2.5rem 2.2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
  },
  bienvenida: {
    fontSize: "1.35rem",
    margin: "0 0 0.3rem",
    color: "var(--tema-titulo, #0b3c60)",
  },
  indicacion: {
    fontSize: "0.9rem",
    color: "#5b6472",
    margin: "0 0 1.5rem",
  },
  botonWrap: {
    display: "flex",
    justifyContent: "center",
  },
  info: {
    marginTop: "1rem",
    fontSize: "0.85rem",
    color: "#5b6472",
  },
  error: {
    marginTop: "1rem",
    fontSize: "0.85rem",
    color: "#a3402f",
  },
};

export default Login;
